












































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import Canvas2Image from '@/service/canvas2image'
import { qs } from '@/service/utils'

@Component( {
    computed: mapGetters( {
        currentImage: 'imagesModule/currentImage'
    } )
} )
export default class BaseSocialSharing extends Vue {
    @Prop() associationContent !: string
    currentImage: any

    createSocialMediaImage() {
        const canvasElement = qs( '.oe-social-media-image' ) as HTMLCanvasElement
        const canvasContext = canvasElement.getContext( '2d' )
        const baseImage = new Image()

        baseImage.src = this.currentImage.url
        // baseImage.crossOrigin = "Anonymous"

        if ( canvasContext ) {
            baseImage.onload = () => {
                canvasContext.drawImage( baseImage, 0, 0 )
                canvasContext.font = '30px GravurCondensed-Regular'
                canvasContext.fillText( this.associationContent, 10, 50 )

                // const newImage = canvasContext.getImageData( 10, 10, 50, 50 )

                // console.log( newImage )
            }
        }
    }
}
